module.exports = __webpack_public_path__ + "static/media/amaia-user-default.f5f6b040.svg";